import { useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { MaterialsQuery } from "../../../graphql/deliveryService/queries/materials";
import { MaterialsPagedFragment } from "../../../models/autogenerated-deliveryService-gql/graphql";
import { handleError } from "../../../utils/graphqlHelper";

interface useMaterialsQueryProps {
  dataAction: (data: MaterialsPagedFragment) => void;
  errorAction?: () => void;
}

const useMaterialsQuery = (props: useMaterialsQueryProps) => {
  const { t } = useTranslation();
  const { dataAction, errorAction } = props;

  const query = useQuery(MaterialsQuery, {
    variables: { offset: 0, limit: 50 },
  });

  const { data, error } = query;

  const materialsPagedFragment = data?.materials;

  useEffect(() => {
    if (!error) return;

    handleError(t("materialsError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !materialsPagedFragment) return;

    dataAction(materialsPagedFragment);
  }, [data]);

  return query;
};

export default useMaterialsQuery;
